import { configureStore } from '@reduxjs/toolkit';

import statsSlice from './slice/stats-slice';
import authSlice from './slice/auth';
import configSlice from './slice/config/config';
import modalSlice from './slice/health-monitor/modal';
import deviceListSlice from './slice/health-monitor/device-list';
import deviceDetailsSlice from './slice/health-monitor/device-details';
import dataReducer from './slice/stats-slice';
import filtersReducer from './slice/filter-slice';
import timeZoneReducer from './slice/timezone-slice';
import exportReducer from './slice/export-slice';
import gamesFilterReducer from './slice/games-slice';
import globalFiltersReducer from './slice/global-filters';
import dateFilterReducer from './slice/date-slice';
import cashRegisterReducer from './slice/cash-register-slice';
import cashRegisterDetailsReducer from './slice/cash-register-details-slice';
import operatorDetailsReducer from './slice/operator-details-slice';
import columnSlice from './slice/column-slice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    configSlice: configSlice,
    modalSlice: modalSlice,
    deviceList: deviceListSlice,
    deviceDetails: deviceDetailsSlice,
    data: dataReducer,
    filters: filtersReducer,
    timeZone: timeZoneReducer,
    export: exportReducer,
    gamesFilter: gamesFilterReducer,
    globalFilters: globalFiltersReducer,
    dateFilter: dateFilterReducer,
    stats: statsSlice,
    cashRegisterData: cashRegisterReducer,
    cashRegisterDetails: cashRegisterDetailsReducer,
    operatorDetails: operatorDetailsReducer,
    columnOrder: columnSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
